import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (common in development)
const resizeObserverErr = window.onerror;
window.onerror = function(msg, source, lineno, colno, error) {
  if (msg && msg.includes && msg.includes('ResizeObserver loop')) {
    return true;
  }
  return resizeObserverErr ? resizeObserverErr(msg, source, lineno, colno, error) : false;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
